<template>
  <div>
    <header v-if="normal_header">
      <div class="contain">
        <img @click="goToSurvyio('/')" class="logo" :src="config.LOGO_PNG" />
        <div v-if="!is_affiliate" class="links">
          <a @click="goToSurvyio('/how-it-works')">How it works</a>
          <a @click="goToSurvyio('/features')">Features</a>
          <a @click="goToSurvyio('/pricing')">Plans & Pricing</a>
          <a class="action" @click="goTo('/register')">
            <span>Login</span> /
            <span>Signup</span>
          </a>
          <button @click="goToSurvyio('/contact')" class="btn text-btn">SCHEDULE DEMO</button>
        </div>
        <div v-else class="links">
          <a class="action" @click="goTo('/register')">
            <span>Login</span> /
            <span>Signup</span>
          </a>
        </div>
        <img @click="mobile = true" class="profile-icon" src="@/assets/img/hamburger.svg" />
      </div>
    </header>

    <transition name="fade">
      <div v-if="mobile" class="mobile-nav">
        <p @click="mobile = false" class="close">x</p>
        <div class="links">
          <a v-if="!is_affiliate" @click="goToSurvyio('/how-it-works')">How it works</a>
          <a v-if="!is_affiliate" @click="goToSurvyio('/features')">Features</a>
          <a v-if="!is_affiliate" @click="goToSurvyio('/pricing')">Plans & Pricing</a>
          <a class="action" @click="goTo('/register')">
            <span>Login</span> /
            <span>Signup</span>
          </a>
          <a v-if="!is_affiliate" @click="goToSurvyio('/contact')">SCHEDULE a Demo</a>
        </div>
      </div>
    </transition>

    <div v-if="!normal_header">
      <header class="admin-header">
        <p>888-317-5531</p>
        <p @click="logout" class="logout">Logout</p>
      </header>

      <transition name="fade">
        <div v-if="show_sidebar" @click="show_sidebar = false" class="offclick"></div>
      </transition>

      <div class="sidebar" :class="{ active: show_sidebar }" v-if="$route.name != 'Accounts'">
        <div v-if="show_sidebar" class="delete-btn" @click="show_sidebar = false">
          <p class="delete">x</p>
        </div>
        <p class="welcome">
          Welcome
          <span>{{ user }}</span>
        </p>
        <div class="account-select" v-if="manager && manager_accounts">
          <p>
            <label>Account Selector:</label>
            <v-select
              @input="choose_account"
              class="input"
              :clearable="false"
              label="name"
              :value="active_account"
              :options="manager_accounts"
            ></v-select>
            <!-- <select class='select' @input="choose_account">
              <option v-for="acc in manager_accounts" :key="acc.val" :value="acc.val" :selected="acc.val == manager.index || (acc.val == -1 && !manager)"> {{ acc.name }} </option>
            </select>-->
          </p>
        </div>
        <div class="navs">
          <div
            v-for="nav in navs"
            class="nav"
            :key="nav.name"
            :class="{
              active:
                $route.path == nav.url
            }"
            @click="checkNav(nav)"
          >
            <!-- <img :src='require("@/assets/img/"+nav.name+".svg")'> -->
            <p>
              {{ nav.name }}
              <img v-if="nav.children" src="@/assets/img/more.svg" />
            </p>
            <div v-if="show_inner_nav == nav.name" class="inner-navs">
              <p
                v-for="(inner_nav, index) in nav.children"
                @click="goTo(inner_nav.url)"
                :key="index"
              >{{ inner_nav.name }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="!normal_header && !show_sidebar && $route.name != 'Accounts'"
      class="mobile-menu-icon"
      @click="show_sidebar = true"
    >
      <img src="@/assets/img/menu.svg" />
    </div>

    <popup></popup>
  </div>
</template>

<script>
import Popup from "@/components/Popup";
import sidebarMenu from "@/utilities/menu.js";
import { db, auth } from "../firebaseConfig.js";
var moment = require("moment");
var tz = require("moment-timezone");
import firebase from "firebase";

export default {
  name: "heading",
  components: {
    popup: Popup
  },
  data() {
    return {
      mobile: false,
      show_inner_nav: null,
      show_sidebar: false,
      swipe: false,
      showPopup: false,
      status: "submit",
      normal_header: null,
      user: null,
      active_account: null
    };
  },
  async created() {
    await this.getAffiliates();
    console.log(this.is_affiliate);
    this.checkRoute();
    firebase.auth().onAuthStateChanged(currentUser => {
      if (currentUser) {
        this.user = currentUser.displayName
          ? currentUser.displayName
          : currentUser.email;
      }
    });
  },
  firestore() {
    return {};
  },
  computed: {
    navs() {
      let navs = [];
      let subsections = {};

      sidebarMenu
        .filter(
          val =>
            !this.$store.state.user_doc.affiliate_id ||
            (this.$store.state.user_doc.affiliate_id &&
              val.name != "subscription")
        )
        .forEach((val, i) => {
          if (
            this.$store.state.manager &&
            !this.$store.state.manager.permissions[val.name]
          ) {
            return true;
          }
          if (val.employee_requests) {
            if (this.$store.state.user_doc.employee_requests) {
              navs.push({
                name: val.display,
                url: `/${val.name}`
              });
            } else {
              return false;
            }
          } else {
            if (val.section) {
              if (!subsections[val.section]) {
                subsections[val.section] = {
                  display: val.section,
                  children: [],
                  index: navs.length
                };
                navs[navs.length] = {
                  name: val.section
                };
              }
              subsections[val.section].children.push({
                name: val.display,
                url: `/${val.name}`
              });
            } else {
              navs.push({
                name: val.display,
                url: `/${val.name}`
              });
            }
          }
        });
      for (const section in subsections) {
        if (subsections.hasOwnProperty(section)) {
          const info = subsections[section];
          navs[info.index].children = info.children;
        }
      }
      return navs;
    },
    manager() {
      return this.$store.state.manager;
    },
    manager_accounts() {
      let choices = [];
      let primary = this.$store.state.accounts.primary;
      if (primary) {
        choices.push({ val: -1, name: primary.company + " - " + primary.name });
      }
      choices = choices.concat(
        ...this.$store.state.accounts.managers.map((val, index) => {
          let name = val.user_doc.company + " - " + val.user_doc.name;
          if (
            index == this.manager.index ||
            (val.index == -1 && !this.manager)
          ) {
            this.active_account = name;
          }
          return { val: index, name: name };
        })
      );
      return choices;
    }
  },
  methods: {
    choose_account(index) {
      console.log(index.val);
      return this.$store.dispatch("setManager", parseInt(index.val));
    },
    checkNav(nav) {
      if (nav.children) {
        if (this.show_inner_nav == nav.name) {
          this.show_inner_nav = null;
        } else {
          this.show_inner_nav = nav.name;
        }
      } else {
        this.goTo(nav.url);
      }
    },
    checkRoute() {
      if (!auth.currentUser) {
        this.normal_header = true;
      } else {
        this.normal_header = false;
      }
    },
    logout() {
      firebase
        .auth()
        .signOut()
        .then(
          () => {
            this.$store.dispatch("signOut");
            this.goToSurvyio("/");
          },
          function(error) {
            // An error happened.
          }
        );
    }
  },
  watch: {
    $route(to, from) {
      this.checkRoute();
      this.mobile = false;
    }
  }
};
</script>

<style lang="scss">
header {
  position: fixed;
  z-index: 99;
  top: 0;
  left: 0;
  padding: 15px 0;
  width: 100%;
  background-color: white;
  box-shadow: 0 0 8px hsla(0, 0%, 50.2%, 0.35);
  .contain {
    padding: 0 100px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    @media screen and (max-width: 900px) {
      padding: 0 50px;
    }
    @media screen and (max-width: 1150px) {
      padding: 0 30px;
    }
    .logo {
      height: 55px;
      cursor: pointer;
    }
    .profile-icon {
      height: 19px;
      display: none;
      cursor: pointer;
      @media screen and (max-width: 1150px) {
        display: block;
      }
    }
    .btns {
      @media screen and (max-width: 1150px) {
        display: none;
      }
    }
    .links {
      display: flex;
      align-items: center;
      @media screen and (max-width: 1150px) {
        display: none;
      }
      .btn {
        margin-left: 30px;
      }
      a {
        margin-left: 35px;
        font-weight: 600;
        cursor: pointer;
        &.action {
          color: #00bf6f;
        }
      }
    }
  }
}

.admin-header {
  padding: 10px 20px;
  background-color: #132628;
  box-shadow: none;
  display: flex;
  z-index: 999999;
  justify-content: space-between;
  box-shadow: 0 0 8px hsla(0, 0%, 50.2%, 0.35);
  p {
    margin: 0;
    color: white;
    font-size: 14px;
  }
  .logout {
    color: #00bf6f;
    cursor: pointer;
  }
}

.sidebar {
  position: fixed;
  z-index: 9999;
  padding-top: 39px;
  left: 0;
  top: 0;
  width: 250px;
  background: white;
  height: 100%;
  box-shadow: 0 0 8px hsla(0, 0%, 50.2%, 0.35);
  transition: margin 0.5s;
  overflow: hidden;
  overflow-y: auto;
  @media screen and (max-width: 950px) {
    margin-left: -250px;
    &.active {
      margin-left: 0;
    }
  }
  .welcome {
    padding: 30px 20px;
    padding-left: 30px;
    margin: 0;
    overflow: hidden;
    span {
      font-size: 21px;
      font-weight: bold;
      font-family: "SFProDisplay", sans-serif;
      display: block;
      overflow: hidden;
    }
  }
  .account-select {
    padding: 0 30px;
    margin-top: -30px;
    label {
      font-size: 12px;
      opacity: 0.7;
    }
    .select {
      padding: 5px 10px;
      box-sizing: border-box;
      width: 100%;
      margin-top: 2px;
    }
  }
  .navs {
    display: flex;
    flex-direction: column;
    .nav {
      width: 100%;
      border-left: 10px solid transparent;
      padding: 17px 20px;
      display: flex;
      cursor: pointer;
      border-top: 2px solid #eaeaea;
      flex-direction: column;
      transition: background-color 0.3s;
      &:last-child {
        border-bottom: 2px solid #eaeaea;
      }
      &:hover {
        background-color: rgba(73, 198, 212, 0.15);
      }
      img {
        height: 20px;
        filter: brightness(0.2);
        margin-right: 15px;
      }
      p {
        margin: 0;
        font-family: "SFProDisplay", sans-serif;
        font-size: 17px;
        font-weight: 500;
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        img {
          opacity: 0.3;
          height: 15px;
          transition: transform 0.3s;
          &.open {
            transform: rotate(180deg);
          }
        }
      }
      .inner-navs {
        margin-top: 10px;
        p {
          font-size: 16px;
          opacity: 0.7;
          padding: 3px 0;
          margin-bottom: 2px;
          transition: opacity 0.3s;
          cursor: pointer;
          &:hover {
            opacity: 1;
          }
        }
      }
      &.active {
        background: #f7f7f7;
        border-left: 10px solid #00bf6f;
        p {
          color: #00bf6f;
          font-weight: bold;
        }
        img {
          filter: none;
        }
      }
    }
  }
  .delete-btn {
    position: absolute;
    right: 0;
    opacity: 0.5;
  }
}

.mobile-menu-icon {
  display: none;
  position: fixed;
  z-index: 9;
  background: #00bf6f;
  padding: 10px 0;
  left: 0;
  top: 88px;
  width: 30px;
  border-top-right-radius: 7px;
  border-bottom-right-radius: 7px;
  cursor: pointer;
  img {
    height: 27px;
    filter: brightness(0) invert(1);
  }
  @media screen and (max-width: 950px) {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.mobile-nav {
  position: fixed;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  padding: 30px;
  z-index: 10;
  background-color: rgba(0, 191, 111, 0.91);
  .links {
    display: flex;
    flex-direction: column;
    padding-top: 100px;
    a {
      color: white;
      font-weight: bold;
      font-size: 35px;
      margin-bottom: 15px;
      cursor: pointer;
      transition: transform 0.3s;
      &:hover {
        transform: scale(0.99);
      }
    }
  }
  p {
    color: white;
    cursor: pointer;
    padding: 15px 20px;
    font-size: 30px;
    position: fixed;
    top: 0;
    right: 0;
    margin: 0;
    font-weight: bold;
    opacity: 1;
    &.close {
      position: fixed;
      top: 70px;
      right: 30px;
    }
  }
}

.offclick {
  position: fixed;
  z-index: 9998;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.35);
}
</style>
